require('./impersonate-template.html');

angular.module('bbl.module.impersonate.controller', [])
  .controller('ImpersonateController', [
    '$scope', '$routeParams', 'modals', 'Auth', '$window',
    impersonateController
  ]);

function impersonateController($scope, $routeParams, modals, Auth, $window) {
  $scope.setViewAs = function($event, username) {
    if($event) {
      $event.preventDefault();
    }

    var redirect = function(response) {
      if(response.status == 401) {
        $scope.errorMessage = response.data.msg;
      }

      $window.location.replace("#/dashboard");
      $window.location.reload();
    };

    Auth.impersonation(username).then(redirect, redirect);
  };

  if($routeParams.userid) {
    $scope.setViewAs(null, $routeParams.userid);
  } else {
    var modal = modals.viewAs($scope);
    modal.modal();
  }
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/impersonate/impersonate.controller.js
 ** module id = 405
 ** module chunks = 0
 **/